import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { RatingsInputDataHooks, RatingsInputDataKeys } from './dataHooks';
import {
  RatingsInputDriver,
  ratingsInputDriverFactory,
} from './RatingsInput.driver';
import { dataHook } from '../../testkitUtils/utils';

export interface RatingsInputPrivateDriver extends RatingsInputDriver {
  hoverStarAt(idx: number): Promise<void>;
  getActiveStarCount(): Promise<number>;
}

export const ratingsPrivateInputDriverFactory = (
  base: UniDriver,
): RatingsInputPrivateDriver => {
  return {
    ...ratingsInputDriverFactory(base),
    hoverStarAt: async (idx: number) => {
      await base
        .$$(dataHook(RatingsInputDataHooks.RatingStarWrapper))
        .get(idx)
        .hover();
    },
    getActiveStarCount: async () => {
      return base
        .$$(dataHook(RatingsInputDataHooks.RatingStar))
        .filter(
          async (el) => (await el.attr(RatingsInputDataKeys.Active)) === 'true',
        )
        .count();
    },
  };
};
